module.exports = __webpack_public_path__ + "img/home_list_icon4.c9d15ea1.png";